export const pageName = {
    GALLERY : 'Gallery',
    ABOUTUS : 'About Us',
    APPOINTMENT: 'Make an appointment',
    ABHAENROLL: 'Create ABHA card (Health ID)',
    DEFAULT : 'Home'
}
export const Mode = {
    DEBUG: false,
    TEST_HOST: "http://127.0.0.1:8000"
}

export const Capability = {
    cap: [
        "name",
        "gallery",
        "social_media",
        "contact",
        "timing",
        "team",
        "treatments",
        "theme",
        "slider",
        "pages",
        "testimonials",
        "overrides",
        "google_tag",
        "features",
        "featured_page",
        "abdm"
      ]
}